export enum EmployerConstants {
  SET_INDUSTRY = 'employer/SET_INDUSTRY',
  SET_OCUPATION = 'employer/SET_OCUPATION',
  SET_PRIMARY_BUSINESS = 'employer/SET_PRIMARY_BUSINESS',
  SET_ADDRESS1 = 'employer/SET_ADDRESS1',
  SET_ADDRESS2 = 'employer/SET_ADDRESS2',
  SET_CITY = 'employer/SET_CITY',
  SET_STATE = 'employer/SET_STATE',
  SET_ZIPCODE = 'employer/SET_ZIPCODE',
  SET_COUNTY = 'employer/SET_COUNTY',
  SET_COUNTRY = 'employer/SET_COUNTRY',
  SET_PHONENUMBER = 'employer/SET_PHONENUMBER',
  SET_PHONETYPE = 'employer/SET_PHONETYPE',
  SET_EMPLOYER = 'employer/SET_EMPLOYER',
  RESET_EMPLOYER_STATE = 'employer/RESET_EMPLOYER_STATE',
  GET_EMPLOYER_COUNTY_OPTIONS = 'employer/GET_EMPLOYER_COUNTY_OPTIONS',
}
